import { authHeader } from "../auth/authHeader";
import axios from "axios";
import { userService } from "./user.services";

async function putMyClinics(data) {
  const options = authHeader("PUT");
  try {
    const response = await axios.put(
      process.env.REACT_APP_ROOT_API + "/user/",
      data,
      { ...options }
    );
    return response;
  } catch (error) {
    return handleError(error);
  }
}

async function getAllClinicsFilter(filter = "") {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + "/clinics/",
      { ...options, params: { clinic_filter: filter } }
    );
    return response.data.results;
  } catch (error) {
    return handleError(error);
  }
}

async function getDepartments(clinic) {
  const options = authHeader();
  try {
    const response = await axios.get(
      process.env.REACT_APP_ROOT_API + "/departments/",
      { ...options, params: { clinic: clinic } }
    );
    return response.data.results;
  } catch (error) {
    return handleError(error);
  }
}

async function getAllClinics(clinicFilter) {
  const requestOptions = authHeader();
  try {
    const response = await fetch(
      `${process.env.REACT_APP_ROOT_API}/clinics/?clinic_filter=${clinicFilter}`,
      requestOptions
    );
    const response_1 = await handleResponse(response);
    return response_1.results;
  } catch (error) {
    return handleError(error);
  }
}
async function getClinicById(id) {
  const requestOptions = authHeader();
  const response = await fetch(
    process.env.REACT_APP_ROOT_API + `/clinics/${id}/`,
    requestOptions
  );
  return await handleResponse(response);
}

async function getUserClinics() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  const response = await fetch(
    process.env.REACT_APP_ROOT_API + `/user/`,
    requestOptions
  );
  return handleResponse(response);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (response.status === 401) {
      userService.logout();
      window.location.replace("/signin");
    }

    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

function handleError(error) {
  if (error.response && error.response.status === 401) {
    userService.logout();
    window.location.replace("/signin");
  }

  return error;
}

export const clinicService = {
  getAllClinics,
  getClinicById,
  getUserClinics,
  getAllClinicsFilter,
  putMyClinics,
  getDepartments,
};
